import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import { userSelector } from 'selectors/user/userSelector';
import { activityPointsSelector } from 'selectors/profile/activityPointsSelector';
import profileActions from 'actions/ProfileActions';

const { wrapHOC } = FrameworkUtils;
const { getAccountActivityPoints } = profileActions;

// Map state to props using createSelector
const fields = createSelector(
    activityPointsSelector,
    userSelector,
    (activityPoints, user) => ({
        activityPoints,
        user,
        records: activityPoints?.records || null,
        error: activityPoints?.error || false,
        totalPages: activityPoints?.totalPages,
        pageNumber: activityPoints?.pageNumber
    })
);

// Map dispatch to props
const functions = dispatch => ({
    getAccountActivityPoints: (profileId, pageSize) => dispatch(getAccountActivityPoints(profileId, pageSize))
});

const withAllPointsActivity = wrapHOC(connect(fields, functions));

export {
    withAllPointsActivity,
    fields,
    functions
};
